<template>
  <!-- <div class="Scheduler-popup"> -->
  <div class="Scheduler-inner">
    <!-- <div class="Scheduler-popup-head bg--blue tx--bege flex flex--center">
      עריכה לתאריך {{ formattedDate }}
      <a href="javascript:void(0)" @click="$emit('close')">
        <CloseSvg- />
      </a>
    </div> -->
    <div id="demo-mobile-day-view"></div>
    <div class="Scheduler-popup-footer bg--white">
      <button
        type="button"
        class="bt_blue bg-block w-100"
        :class="{ disabled: !eventsToSave.length }"
        @click="eventsToSave.length ? rescheduleAppointments() : null"
      >
        שמירה
        <vue-loaders-ball-clip-rotate
          v-show="isLoading"
          color="#324997"
          scale="1.2"
          style="position: relative;top: 9px;"
        ></vue-loaders-ball-clip-rotate>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
// import CloseSvg from "@/assets/img/svg/close.svg";
import Error from "@/components/Popups/Error";
// import UnsavedChangesAlert from "@/components/Popups/UnsavedChangesAlert";
import "@mobiscroll/javascript/dist/css/mobiscroll.min.css";
var mobiscroll = require("@mobiscroll/javascript");

export default {
  name: "Scheduler",
  data() {
    return {
      inst: null,
      cal: null,
      rescheduleBlockId: "",
      currentDragEvent: null,
      isNewEvent: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "selectedDateMobiscroll",
      "appointmentsMobiscroll",
      "blocksMobiscroll",
      "startTimeMobiscroll",
      "endTimeMobiscroll",
      "isSelectedDatePassedMobiscroll",
      "eventsToSave"
    ]),
    formattedDate() {
      return this.$moment(this.selectedDateMobiscroll, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
    },
    isSelectedDateToday() {
      if (!this.selectedDateMobiscroll) return false;
      const today = this.$moment().format("YYYY-MM-DD");
      const selectedDate = this.$moment(
        this.selectedDateMobiscroll,
        "YYYY-MM-DD"
      );
      return selectedDate.isSame(this.$moment(today, "YYYY-MM-DD"));
    },
    existShortAppointments() {
      for (let i = 0; i < this.appointmentsMobiscroll.length; i++) {
        const res = this.isShortAppointment(
          this.appointmentsMobiscroll[i].start,
          this.appointmentsMobiscroll[i].end
        );
        if (res) return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["UPDATE_EVENTS_TO_SAVE", "TOGGLE_MOBISCROLL"]),
    initCalendar() {
      let that = this;

      return mobiscroll.eventcalendar("#demo-mobile-day-view", {
        theme: "ios",
        themeVariant: "light",
        clickToCreate: false,
        dragToCreate: false,
        dragToMove: that.isSelectedDatePassedMobiscroll ? false : true,
        dragToResize: that.isSelectedDatePassedMobiscroll ? false : true,
        eventDelete: false,
        locale: mobiscroll.localeHe,
        view: {
          schedule: {
            type: "day",
            allDay: false,
            startTime: that.startTimeMobiscroll,
            endTime: that.endTimeMobiscroll,
            timeCellStep: that.existShortAppointments ? 5 : 15,
            timeLabelStep: 15
            // currentTimeIndicator: true
          }
        },
        dragTimeStep: 5,
        // rtl: true,
        colors: that.blocksMobiscroll, // blocks
        renderHeader: function() {
          return "";
        },
        renderScheduleEvent: function(data) {
          // custom event function
          // New event
          if (data.original.title == "New event") {
            return `<div class="mbsc-font-inner" style="background-color: #FFF8B5;">תור חדש</div>`;
          }

          const index = that.eventsToSave.findIndex(
            e => e.id == data.original.id
          );
          let backgroundStyle = "";
          if (index != -1) {
            backgroundStyle = ' style="background-color: #FFF8B5;"';
          }
          if (that.currentDragEvent == data.original.id) {
            backgroundStyle =
              ' style="background-color: #F1CA69; box-shadow: 0 4px 22px 0 rgba(0,0,0,.2)"';
          }
          return `<div class="mbsc-font-inner"${backgroundStyle}'">
          <span class="bolden">${data.start}-${data.end}</span> ${data.original.content}
        </div>`;
        },
        // rooms
        resources: [
          // {
          //   id: 1,
          //   name: "Ryan",
          //   color: "#f7c4b4",
          //   img: "https://img.mobiscroll.com/demos/m1.png"
          // },
        ],
        //   renderResource: function (resource) {
        //     return '<div class="header-resource-template-content">' +
        //         '<img class="header-resource-avatar" src="' + resource.img + '"/>' +
        //         '<div class="header-resource-name">' + resource.name + '</div>' +
        //         '</div>';
        // },
        onCellClick: function(event, inst) {
          if (that.isNewEvent) return;

          if (that.eventsToSave && that.eventsToSave.length) {
            mobiscroll.toast({
              message:
                "יש לשמור תחילה את השינויים שנעשו ורק לאחר מכן ניתן יהיה לקבוע תור חדש."
            });
          } else {
            that.createNewEvent(event);
          }
        },
        onCellDoubleClick: function(event, inst) {},
        onCellRightClick: function(event, inst) {},
        onDestroy: function(event, inst) {},
        onEventClick: function(event, inst) {
          // Logic for event click
          if (event.event.title != "New event") return;

          if (that.eventsToSave && that.eventsToSave.length) {
            mobiscroll.toast({
              message:
                "יש לשמור תחילה את השינויים שנעשו ורק לאחר מכן ניתן יהיה לקבוע תור חדש."
            });
            // that.$modal.show(UnsavedChangesAlert, {
            //   confirmFunc: ev => {
            //     if (ev) that.saveNewEvent(event.event);
            //   }
            // });
          } else {
            that.saveNewEvent(event.event);
          }
        },
        onEventCreate: function(event, inst) {},
        onEventCreated: function(event, inst) {},
        onEventCreateFailed: function(event, inst) {},
        onEventDelete: function(event, inst) {},
        onEventDeleted: function(event, inst) {},
        onEventDoubleClick: function(event, inst) {},
        onEventDragStart: function(args, inst) {
          // Logic for event drag start
          that.currentDragEvent = args.event.id;
        },
        onEventDragEnd: function(args, inst) {
          // Logic for event drag end
          that.currentDragEvent = null;
          // If new event is created then remove it
          const foundNewEvent = that.cal
            .getEvents()
            .find(e => e.title == "New event");
          if (foundNewEvent && args.event.title != "New event") {
            that.cal.removeEvent(foundNewEvent);
            that.newEvent = false;
            mobiscroll.toast({
              message:
                "לא ניתן ליצור תור חדש ולבצע שינויים בתורים שקימיים באותו הזמן."
            });
          }
        },
        onEventHoverIn: function(event, inst) {},
        onEventHoverOut: function(event, inst) {},
        onEventUpdate: function(args, inst) {
          if (that.isSelectedDateToday) {
            // check if it's today and time is passed
            const res = that.checkTimePassed(args.oldEvent, args.event);
            if (res) {
              that.removeEvFromCalcEventsArr(args.event.id);
              mobiscroll.toast({
                message: res
              });
              return false;
            }
          }
        },
        onEventUpdated: function(event, inst) {
          // Logic for event updated
          that.saveEventToEdit(event.event);
          // that.rescheduleApp(event.event);
        },
        onEventUpdateFailed: function(event, inst) {},
        onEventRightClick: function(event, inst) {},
        onInit: function(event, inst) {},
        onPageChange: function(event, inst) {},
        onPageLoaded: function(event, inst) {},
        onPageLoading: function(event, inst) {},
        onSelectedDateChange: function(event, inst) {}
      });
    },
    triggerMouseEnter(el) {
      // Function to programmatically trigger mouseenter
      const mouseEnterEvent = new Event("mouseenter", {
        bubbles: true,
        cancelable: true
      });
      el.dispatchEvent(mouseEnterEvent);
      el.click();
    },
    isShortAppointment(start, end) {
      // check if appointment is less than 5 minutes
      const startTime = this.$moment(start);
      const endTime = this.$moment(end);
      const durationInMinutes = endTime.diff(startTime, "minutes");
      return durationInMinutes < 15;
    },
    checkAppWithinBlock(start, end) {
      const appointmentStartTime = this.$moment(start);
      const appointmentEndTime = this.$moment(end);
      const blocks = this.blocksMobiscroll;
      if (!blocks.length) return null;

      for (const block of blocks) {
        const blockStartTime = this.$moment(block.start);
        const blockEndTime = this.$moment(block.end);

        if (
          appointmentStartTime.isSameOrAfter(blockStartTime) &&
          appointmentEndTime.isSameOrBefore(blockEndTime)
        ) {
          this.rescheduleBlockId = block.id;
          return block.id;
        }
      }
      return null;
    },
    checkAppOverlap(start, end, events, checkBeforeEdit = false) {
      let isOverlap = false;
      const providedStartTimeMoment = this.$moment(start);
      const providedEndTimeMoment = this.$moment(end);

      for (const appointment of events) {
        const appointmentStartTime = this.$moment(
          checkBeforeEdit ? appointment.real_start : appointment.start
        );
        const appointmentEndTime = this.$moment(
          checkBeforeEdit ? appointment.real_end : appointment.end
        );

        if (
          providedStartTimeMoment.isBetween(
            appointmentStartTime,
            appointmentEndTime,
            null,
            "[)"
          ) ||
          providedEndTimeMoment.isBetween(
            appointmentStartTime,
            appointmentEndTime,
            null,
            "(]"
          ) ||
          (providedStartTimeMoment.isSameOrBefore(appointmentStartTime) &&
            providedEndTimeMoment.isSameOrAfter(appointmentEndTime))
        ) {
          isOverlap = true;
          break;
        }
      }
      return isOverlap;
    },
    hasOverlap(ev, checkBeforeEdit = false) {
      const events = this.cal.getEvents().filter(e => e.id !== ev.id);
      const isAppOverlap = this.checkAppOverlap(
        ev.start,
        ev.end,
        events,
        checkBeforeEdit
      );
      if (isAppOverlap) {
        return "לתשומת ליבך, לא ניתן לזמן תור כפול באותה שעה.";
      }
      const isAppInsideBlock = this.checkAppWithinBlock(ev.start, ev.end);
      if (!isAppInsideBlock) {
        return "לתשומת ליבך, לא ניתן לקבוע תור מחוץ לשעות הבלוק יש לבחור שעה אחרת או לעדכן את שעות הבלוק.";
      }

      return "";
    },
    saveEventToEdit(ev) {
      if (ev.title == "New event") return;
      this.checkAppWithinBlock(ev.start, ev.end);
      const appointment = {
        id: ev.id,
        start: this.$moment(ev.start).format("YYYY-MM-DDTLT:00"),
        end: this.$moment(ev.end).format("YYYY-MM-DDTLT:00"),
        over_block_id: this.rescheduleBlockId,
        title: "appointment"
      };
      const index = this.eventsToSave.findIndex(e => e.id == appointment.id);
      let tmp = [...this.eventsToSave];
      if (index == -1) tmp.push(appointment);
      else tmp[index] = appointment;
      this.UPDATE_EVENTS_TO_SAVE(tmp);
      this.rescheduleBlockId = "";
      // const inset = this.cal.getInst();
      // inset.updateEvent(ev)
    },
    async rescheduleAppointments() {
      if (this.isLoading) return;

      const allEvents = this.cal.getEvents();
      for (let i = 0; i < allEvents.length; i++) {
        const res = this.hasOverlap(allEvents[i]);
        if (res) {
          mobiscroll.toast({
            message: res
          });
          return;
        }
      }
      try {
        this.isLoading = true;
        await this.$API.setAppointementsDatetime(this.eventsToSave);
        this.$root.$emit("rescheduleSurgery");
        setTimeout(() => {
          this.cal.setEvents(this.appointmentsMobiscroll);
          this.UPDATE_EVENTS_TO_SAVE([]);
          this.currentDragEvent = null;
          this.isNewEvent = false;
          this.isLoading = false;
        }, 700);
        // const evsEl = document.querySelectorAll(".mbsc-schedule-event");
        // if (evsEl && evsEl.length) {
        //   evsEl.forEach(el => this.triggerMouseEnter(el));
        // }
      } catch (error) {
        this.$modal.show(Error);
        this.isLoading = false;
      }
    },
    checkTimePassed(oldEvent, event) {
      const today = this.$moment();
      const oldEventStart = this.$moment(oldEvent.start);
      const eventStart = this.$moment(event.start);
      const eventEnd = this.$moment(event.end);
      if (today.isAfter(oldEventStart)) {
        return "זמן התור עבר ולא ניתן לעריכה.";
      } else if (today.isAfter(eventStart) || today.isAfter(eventEnd)) {
        return "לא ניתן לערוך תור לזמן שכבר עבר.";
      }
      return "";
    },
    removeEvFromCalcEventsArr(eventId) {
      const index = this.eventsToSave.findIndex(ev => ev.id == eventId);
      if (index != -1) {
        let tmp = [...this.eventsToSave];
        tmp.splice(index, 1);
        this.UPDATE_EVENTS_TO_SAVE(tmp);
      }
      if (eventId == this.currentDragEvent) this.currentDragEvent = null;
    },
    createNewEvent(event) {
      const endDate = this.$moment(event.date)
        .add(15, "minutes")
        .format("YYYY-MM-DDTHH:mm:ss");

      const newEvent = {
        allDay: false,
        end: endDate,
        id: "new",
        start: event.date,
        title: "New event"
      };

      // check if time is passed
      const res = this.checkTimePassed(newEvent, newEvent);
      if (res) {
        mobiscroll.toast({
          message: "לא ניתן לקבוע תור בזמן שכבר עבר."
        });
        return false;
      }

      this.isNewEvent = true;
      this.cal.setEvents([...this.appointmentsMobiscroll, newEvent]);
    },
    saveNewEvent(event) {
      const res = this.hasOverlap(event, true);
      if (res) {
        mobiscroll.toast({
          message: res
        });
        return;
      }
      const blockId = this.checkAppWithinBlock(event.start, event.end);
      this.$emit("toggleShowAppointment", true);
      this.TOGGLE_MOBISCROLL(false);
      this.$router.push(
        "/app-add?start=" +
          this.$moment(event.start).format("YYYY-MM-DDTLT:00") +
          "&end=" +
          this.$moment(event.end).format("YYYY-MM-DDTLT:00") +
          "&block_id=" +
          blockId
      );
    }
  },
  mounted() {
    this.cal = this.initCalendar();
    this.cal.navigate(this.selectedDateMobiscroll);
    this.cal.setEvents(this.appointmentsMobiscroll);
  },
  watch: {
    selectedDateMobiscroll() {
      if (this.cal) this.cal.destroy();
      document.getElementById("demo-mobile-day-view").innerHTML = "";
      this.inst = null;
      this.cal = null;
      this.rescheduleBlockId = "";
      this.currentDragEvent = null;
      this.isNewEvent = false;
      setTimeout(() => {
        this.cal = this.initCalendar();
        this.cal.navigate(this.selectedDateMobiscroll);
        this.cal.setEvents(this.appointmentsMobiscroll);
      }, 100);
    }
  }
};
</script>

<style>
.mbsc-calendar-wrapper,
.mbsc-schedule-header {
  display: none;
}

.mbsc-schedule-time-col {
  width: 3.5em;
}
</style>
